<template>
    <li
        v-if="menu.items"
        v-show="menu.items.length > 0"
        class="menu-item has-child"
        :class="{ active: active, open: open }"
        tabindex="0"
        @mouseenter="calcStyle(0, $event)"
        @mouseleave="resetStyle(0)"
    >
        <!-- first-level menu -->
        <a
            class="has-child-a"
            :class="mainMenuClass"
            @click="menuExpand(0)"
            v-bind="getFirstLink(menu)"
            tabindex="0"
            role="button"
            rel="noopener noreferrer"
        >
            <slot name="first">
                <i
                    v-show="showMenuArrow && isMore && showMoreLeft"
                    class="iconfont left icon-fashion-down"
                ></i>
                <div v-if="menu.displayHtml" v-html="menu.displayHtml"></div>
                <template v-else>{{ getMenuName(menu) }}</template>
                <i v-if="menu.lock" class="iconfont icon-lock"></i>
                <template v-if="!isMore">
                    <i
                        v-show="showMenuArrow"
                        class="iconfont"
                        :class="arrowIcon"
                    ></i>
                </template>
                <i
                    v-show="showMenuArrow && isMore && !showMoreLeft"
                    class="iconfont right icon-fashion-down"
                ></i>
            </slot>
        </a>
        <div ref="wrapper" class="wrapper" :style="wrapperStyle">
            <ol class="submenu hidden-scrollbar" :style="submenuStyle">
                <li
                    v-for="(item, index) in menu.items"
                    :key="item.name + index"
                    class="menu-item"
                    :class="{ open: cOpen[index] }"
                    @mouseenter="calcStyle(1, $event)"
                >
                    <!--has submenu second-level menu -->
                    <template v-if="item.items && item.items.length">
                        <slot name="second">
                            <a
                                class="has-child-a"
                                tabindex="0"
                                role="button"
                                @click="menuExpand(1, index)"
                                rel="noopener noreferrer"
                                v-bind="getFirstLink(item)"
                            >
                                <i
                                    v-show="showMenuArrow && showLeftArrow"
                                    class="iconfont left icon-fashion-down"
                                ></i>
                                <div
                                    v-if="item.displayHtml"
                                    v-html="item.displayHtml"
                                ></div>
                                <template v-else>
                                    {{ getMenuName(item) }}
                                </template>
                                <i
                                    v-show="showMenuArrow && !showLeftArrow"
                                    :class="[
                                        'iconfont',
                                        'right',
                                        isMobile
                                            ? arrowIcon
                                            : 'icon-fashion-down'
                                    ]"
                                ></i>
                            </a>
                        </slot>

                        <!-- third-level menu -->
                        <div class="wrapper" :style="cWrapperStyle">
                            <ol
                                class="submenu hidden-scrollbar"
                                :style="cSubmenuStyle"
                            >
                                <li
                                    v-for="(cItem, cIndex) in item.items"
                                    :key="cItem.name + cIndex"
                                    class="menu-item"
                                >
                                    <slot name="third">
                                        <a
                                            :href="cItem.link"
                                            :target="cItem.target"
                                            @click="hideMenu"
                                            rel="noopener noreferrer"
                                        >
                                            <div
                                                v-if="cItem.displayHtml"
                                                v-html="cItem.displayHtml"
                                            ></div>
                                            <template v-else>{{
                                                getMenuName(cItem)
                                            }}</template>
                                        </a>
                                    </slot>
                                </li>
                            </ol>
                        </div>
                    </template>
                    <!--not has submenu second-level menu -->
                    <slot v-else name="second" :row="item">
                        <a
                            :href="item.link"
                            :target="item.target"
                            rel="noopener noreferrer"
                            @click="hideMenu"
                        >
                            <div
                                v-if="item.displayHtml"
                                v-html="item.displayHtml"
                            ></div>
                            <template v-else>{{ getMenuName(item) }}</template>
                        </a>
                    </slot>
                </li>
            </ol>
        </div>
    </li>
    <li v-else class="menu-item" :class="{ active: active }">
        <slot name="first">
            <a
                :href="menu.link"
                :target="menu.target"
                rel="noopener noreferrer"
                @click="hideMenu"
                :class="mainMenuClass"
            >
                <div v-if="menu.displayHtml" v-html="menu.displayHtml"></div>
                <template v-else>{{ getMenuName(menu) }}</template>
            </a>
        </slot>
    </li>
</template>

<script>
import util from '../../common/util.js';
import { mapState } from 'pinia';
import { usePageStore, useUserStore } from '@/store';
import { defaultLngCode } from '@/globalization/constant.js';

export default {
    name: 'HeaderMenuItem',
    props: {
        menu: {
            type: Object,
            default: () => ({
                name: 'Home',
                link: '/',
                target: '_self',
                visible: 1
            })
        },
        arrowIcon: {
            type: String,
            default: 'icon-fashion-down'
        },
        isMore: {
            type: Boolean,
            default: false
        },
        showMenuArrow: {
            type: Boolean,
            default: false
        },
        mainMenuClass: {
            type: String,
            default: 'uppercase'
        },
        theme: {
            type: String,
            default: ''
        }
    },
    inject: ['hideMenu'],
    data: function() {
        return {
            open: false,
            cOpen: {},
            wrapperStyle: {},
            cWrapperStyle: {},
            submenuStyle: {},
            cSubmenuStyle: {},
            active: false,
            direction: '',
            showLeftArrow: false, // Whether to show the left menu arrow   need CHIME-12779
            showMoreLeft: true // as more Case ， logically a first level menu ， But the display form is a secondary menu ， The arrow changes with the distance between the left and right sides
        };
    },
    mounted() {
        this.getActive();
    },
    computed: {
        ...mapState(useUserStore, {
            user: store => store.user,
        }),
        ...mapState(usePageStore, {
            page: store => store.page,
            currentLanguage: store => store.currentLanguage
        }),
        isMobile() {
            return this.platform.isMobile;
        },
        globalData({ page }) {
            return page;
        },
        links() {
            const links = [];
            if (this.menu.items && this.menu.items.length) {
                const menutItems = this.menu.items;
                for (let i = 0, len = menutItems.length; i < len; i++) {
                    const item = menutItems[i];
                    if (item.items && item.items.length) {
                        const itemItems = item.items;
                        for (
                            let j = 0, jlen = itemItems.length;
                            j < jlen;
                            j++
                        ) {
                            links.push(itemItems[j].link);
                        }
                    } else if (item.link) {
                        links.push(item.link);
                    }
                }
            } else if (this.menu.link) {
                links.push(this.menu.link);
            }
            return links;
        }
    },
    methods: {
        // ...rootMapActions(usePageStore, ['setCurrentLink']),
        getMenuName(menu) {
            return (
                menu.sysLanguage?.[this.currentLanguage]?.name ||
                menu.sysLanguage?.[defaultLngCode]?.name ||
                menu.name
            );
        },
        resetStyle() {
            this.wrapperStyle = {};
        },
        calcStyle(type, event) {
            if (!this.isMobile) {
                const ele = event.target;
                const rect = ele.getBoundingClientRect();
                const headerContainer =
                    this.$parent.$el.querySelector('.header-container');
                const headerContainerStyle = util.getStyle(headerContainer);
                const eleTop =
                    headerContainerStyle['position'] === 'fixed'
                        ? rect.top - headerContainer.offsetTop
                        : rect.top;
                if (!this.direction) {
                    let total = document.documentElement.clientWidth;
                    if (total - rect.right > rect.left || this.isMobile) {
                        this.direction = 'right';
                        this.showLeftArrow = false;
                    } else {
                        this.direction = 'left';
                        this.showLeftArrow = true;
                    }
                }
                let style = {
                    top: eleTop + 'px',
                    maxHeight: window.innerHeight - eleTop + 'px'
                };
                if (this.direction == 'left') {
                    style.right =
                        document.documentElement.clientWidth - rect.left + 'px'; 
                } else {
                    style.left = rect.right + 'px'; 
                }

                if (type === 0) {
                    if (this.isMore) {
                        this.wrapperStyle = style; 
                    } else {
                        style = {};
                        let right =
                            this.$refs.wrapper?.getBoundingClientRect().right ?? 0;
                        if (right > window.innerWidth) {
                            style = {
                                left: window.innerWidth - right - 20 + 'px'
                            };
                        }
                        this.wrapperStyle = style;
                    }
                } else {
                    this.cWrapperStyle = style;
                }
                this.$nextTick(() => {
                    const subEle = ele.querySelector('.submenu');
                    if (subEle) {
                        const subRect = subEle.getBoundingClientRect();
                        let style = null;
                        if (
                            window.innerHeight - subRect.top <
                                subEle.offsetHeight + 20 ||
                            window.innerHeight - subRect.top <
                                subEle.scrollHeight + 20
                        ) {
                            style = {
                                overflow: 'auto',
                                maxHeight:
                                    window.innerHeight - subRect.top - 20 + 'px'
                            };
                        }
                        if (type === 0) {
                            // if (this.secBgColor) {
                            //     style = {
                            //         ...style,
                            //         backgroundColor: this.secBgColor
                            //     };
                            // }
                            this.submenuStyle = style;
                        } else {
                            this.cSubmenuStyle = style;
                        }
                    }
                });
            }
        },
        menuExpand(type, index) {
            if (type === 0) {
                this.open = !this.open;
            } else {
                this.cOpen[index] = !this.cOpen[index];
            }
        },
        getActive() {
            let path = this.pageLocation.pathname;
            if (/dev\/page.html$/.test(path)) {
                path = '/' + (this.pageLocation.query.pagename || ''); //debug local
            }
            if (path === '/about/buyer' || path === '/about/seller') {
                path = '/about';
            }
            for (let i = 0, len = this.links.length; i < len; i++) {
                let link = this.links[i],
                    linkPath = link.split('?')[0];
                if (linkPath != path) {
                    continue;
                }
                if (this.page.currentLink == linkPath) {
                    this.active = true;
                    break;
                }
                let linkItem = util.getQueryField('sitemenuitem', link),
                    pathItem = this.pageLocation.query.sitemenuitem || '';
                if ((!linkItem && !pathItem) || linkItem === pathItem) {
                    // this.setCurrentLink(this.links[i]);
                    this.active = true;
                    break;
                }
            }
            return false;
        },
        getFirstLink(menu) {
            if (!menu || this.isMobile) {
                return {};
            }
            if (menu.items) {
                if (menu.items.length > 0) {
                    return this.getFirstLink(menu.items[0]);
                }
                return {};
            }
            return {
                href: this.theme === 'layout1' ?  "#" : menu.link,
                target: menu.target
            };
        }
    }
};
</script>

<style lang="scss">
.menu-item .uppercase {
    text-transform: uppercase;
}
.menu-item .capitalize {
    text-transform: capitalize;
}
.icon-fashion-down,
.icon-arrow_08_down {
    font-weight: bold;
    font-size: 12px;
    &.left {
        display: inline-block;
        position: absolute;
        left: 3px;
        transform: rotate(-90deg) scale(0.7) !important;
    }
    &.right {
        transform: rotate(90deg) scale(0.7) !important;
    }
    display: inline-block;
    margin-left: 4px;
}
.icon-arrow_08_down {
    font-weight: normal;
}
</style>
